

export const BaseUrl = 'https://admin.foodweb-nautilius.ksoftpl.com/api';
export const AssetsUrl = 'https://admin.foodweb-nautilius.ksoftpl.com'; 

global.BaseUrl = 'https://admin.foodweb-nautilius.ksoftpl.com/api';
global.AssetsUrl = 'https://admin.foodweb-nautilius.ksoftpl.com';


